import { render, staticRenderFns } from "./originalsLayout.vue?vue&type=template&id=a08863f4&"
import script from "./originalsLayout.vue?vue&type=script&lang=js&"
export * from "./originalsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports